"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = (0, _immutable.Record)({
  namespace: null,
  defaultLinkId: null,
  calendarIdsToCheck: null,
  calendarDisplayNames: null,
  customHostedDomainName: null,
  ewsUri: null,
  calendarUsername: null
}, 'StagedSettingsChanges');

exports.default = _default;
module.exports = exports.default;